const toggleSocials = () => {
	const share = document.querySelector('.social-share');
	if (share) {
		const toggle = share.querySelector('[data-toggle-socials]');
		const socials = share.querySelector('.socials-list');
		toggle.addEventListener('click', () => {
			toggle.classList.toggle('socials--open')
			toggle
				.querySelector('.share-list__item__icon')
				.classList.toggle('share-list__item__icon--open');
			socials.classList.toggle('socials-list--visible');
			toggle.getAttribute('aria-expanded') === "false"
				? toggle.setAttribute('aria-expanded', "true")
				: toggle.setAttribute('aria-expanded', 'false');
		});
	}
};

const btnCopy = () => {
	const btn = document.querySelector('[data-copy]') || null;
	if (btn) {
		const url = btn.getAttribute('data-url');
		btn.addEventListener('click', () => {
			navigator.clipboard.writeText(url);
			const parent = btn.parentNode as HTMLElement;
			parent.insertAdjacentHTML(
				'beforeend',
				`
			<span class="click-copy">Lien copié</span>`
			);
			const msg = document.querySelector('.click-copy');
			setTimeout(() => {
				if (msg) msg.remove();
			}, 1000);
		});
	}
};



toggleSocials();
btnCopy();
